(function () {
	angular
		.module('trackeye')
		.controller('DashboardController', DashboardController);

	DashboardController.$inject = ["$scope", "$state", "AuthService", "AccountService", "DeviceService", "OpenLayersService", "AppFactory", "LogService"];

	function DashboardController($scope, $state, AuthService, AccountService, DeviceService, OpenLayersService, AppFactory, Log) {
		if (!AuthService.hasToken()) {
			$state.go('main');
			return;
		}
		
		AccountService.fetch().then(function (account) {
			if (AuthService.isImpersonating()) {
				Log.setAccount('impersonating:' + account.email);
			} else {
				Log.setAccount(account.email);
			}
		});

		var vm = this;

		vm.app = AppFactory;
		vm.hideSidebar = false;
		vm.account = AccountService.get();

		DeviceService.init(vm.account);

		/**
		 * @todo Should not be using timeouts to trigger resizing of map.
		 */
		$scope.$on('Sidebar.collapse', function (e) {
			vm.hideSidebar = true;
			setTimeout(function () {
				OpenLayersService.updateSize();
			}, 100);
		});

		$scope.$on('Sidebar.open', function (e) {
			vm.hideSidebar = false;
			setTimeout(function () {
				OpenLayersService.updateSize();
			}, 100);
		});
	}
})();